import { render } from "./FormAuth.vue?vue&type=template&id=404e0592&scoped=true"
import script from "./FormAuth.vue?vue&type=script&lang=js"
export * from "./FormAuth.vue?vue&type=script&lang=js"

import "./FormAuth.vue?vue&type=style&index=0&id=404e0592&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404e0592"]])

export default __exports__